import { MentionSearchFacetTypesEnum } from '../../../api/mentions/enum/mention-search-facet-types.enum';
import { GoogleAnalyticsReportRequestTypeEnum } from '../../../api/externalData/enums/google-analytics-report-request-type.enum';
import { ReportBlockTypeApiEnum } from '../../../api/reports/enum/report-block-type-api.enum';
import { DimensionsModel } from '../../Misc/models/dimensions.model';
import { AggregateDateFacetTypesEnum } from '../../../api/mentions/enum/aggregate-date-facet-types.enum';
import { NeoFacetRequestApiModel } from '../../../api/mentions/model/neo-facet-request-api.model';
import {
    totalEngagementFacet,
    audienceReachNeoFacet,
    coverageOverTimeNeoFacet,
    engagementsNeoFacet,
    sentimentTrendNeoFacet,
    socialCoverageByNetworkNeoFacet,
    mapChartNeoFacet
} from '../models/report-neo-facet-requests.model';
import { ChartSpecificTypesEnum } from './chart-specific-types.enum';


export enum ReportBlockTypeEnum {
    COVERAGE_OVER_TIME = 'COVERAGE_OVER_TIME',
    SENTIMENT_BREAKDOWN = 'SENTIMENT_BREAKDOWN',
    MEDIA_TYPE_BREAKDOWN = 'MEDIA_TYPE_BREAKDOWN',
    GEOGRAPHY_BREAKDOWN_BY_VOLUME = 'GEOGRAPHY_BREAKDOWN_BY_VOLUME',
    TOP_10_OUTLETS = 'TOP_10_OUTLETS_BY_VOLUME',
    TOP_10_AUTHORS_BY_VOLUME = 'TOP_SOCIAL_INFLUENCER',
    WORD_CLOUD = 'WORD_CLOUD',
    AUDIENCE_REACH_OVER_TIME = 'AUDIENCE_REACH_OVER_TIME',
    AUDIENCE_REACH_OVER_TIME_COMPARISON = 'AUDIENCE_REACH_OVER_TIME_COMPARISON',
    AUDIENCE_REACH_BY_MEDIA_TYPE = 'AUDIENCE_REACH_BY_MEDIA_TYPE',
    AD_VALUE_EQUIVALENCY = 'AD_VALUE_EQUIVILANCY',
    AD_VALUE_EQUIVALENCY_COMPARISON = 'AD_VALUE_EQUIVALENCY_COMPARISON',
    POSITION_BREAKDOWN = 'POSITION_BREAKDOWN',
    SHARE_OF_VOICE = 'SHARE_OF_VOICE',
    COVERAGE_OVER_TIME_COMPARISON = 'COVERAGE_OVER_TIME_COMPARISON',
    COVERAGE_COMPARISON = 'COVERAGE_COMPARISON',
    SENTIMENT_BREAKDOWN_COMPARISON = 'SENTIMENT_BREAKDOWN_COMPARISON',
    SENTIMENT_TREND = 'SENTIMENT_TREND',
    MEDIA_TYPE_BREAKDOWN_COMPARISON = 'MEDIA_TYPE_BREAKDOWN_COMPARISON',
    GEOGRAPHY_BREAKDOWN_COMPARISON = 'GEOGRAPHY_BREAKDOWN_COMPARISON',
    COVERAGE_SUMMARY = 'COVERAGE_SUMMARY',
    TOP_HASHTAGS = 'TOP_HASHTAGS',
    COVERAGE_IMPACT_TREND = 'COVERAGE_IMPACT_TREND',
    REFERRAL_TREND = 'REFERRAL_TREND',
    PROMINENCE_OVER_TIME = 'PROMINENCE_OVER_TIME',
    PROMINENCE_BY_REACH = 'PROMINENCE_BY_REACH',
    TOP_SOCIAL_REFERRERS = 'TOP_SOCIAL_REFERRERS',
    TOP_REFERRAL_SOURCES = 'TOP_REFERRAL_SOURCES',
    RECENT_TOPICS = 'RECENT_TOPICS',
    RECENT_TARGETING_ACTIVITY = 'RECENT_TARGETING_ACTIVITY',
    RECENT_DISTRIBUTION_ACTIVITY = 'RECENT_DISTRIBUTION_ACTIVITY',
    RECENT_REPORTS_DISTRIBUTIONS = 'RECENT_REPORTS_DISTRIBUTIONS',
    SOCIAL_COVERAGE_BY_NETWORK = 'SOCIAL_COVERAGE_BY_NETWORK',
    TOP_TERMS = 'TOP_TERMS',
    RECENT_SURGE_ALERTS = 'RECENT_SURGE_ALERTS',
    TOP_MENTIONS = 'TOP_MENTIONS',
    TOP_POSTS = 'TOP_POSTS',
    SENTIMENT_BY_MEDIA_TYPE = 'SENTIMENT_BY_MEDIA_TYPE',
    COVERAGE_METRIC = 'COVERAGE_METRIC'
}

export const reportBlockTypeEnumToApi = new Map<ReportBlockTypeEnum, ReportBlockTypeApiEnum>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, ReportBlockTypeApiEnum.COVERAGE_OVER_TIME],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN, ReportBlockTypeApiEnum.SENTIMENT_BREAKDOWN],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN, ReportBlockTypeApiEnum.MEDIA_TYPE_BREAKDOWN],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, ReportBlockTypeApiEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, ReportBlockTypeApiEnum.TOP_10_OUTLETS],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, ReportBlockTypeApiEnum.TOP_SOCIAL_INFLUENCERS],
    [ReportBlockTypeEnum.TOP_HASHTAGS, ReportBlockTypeApiEnum.TOP_HASHTAGS],
    [ReportBlockTypeEnum.WORD_CLOUD, ReportBlockTypeApiEnum.WORD_CLOUD],
    [ReportBlockTypeEnum.AUDIENCE_REACH_BY_MEDIA_TYPE, ReportBlockTypeApiEnum.AUDIENCE_REACH_BY_MEDIA_TYPE],
    [ReportBlockTypeEnum.POSITION_BREAKDOWN, ReportBlockTypeApiEnum.POSITION_BREAKDOWN],
    [ReportBlockTypeEnum.SHARE_OF_VOICE, ReportBlockTypeApiEnum.SHARE_OF_VOICE],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, ReportBlockTypeApiEnum.COVERAGE_OVER_TIME_COMPARISON],
    [ReportBlockTypeEnum.COVERAGE_COMPARISON, ReportBlockTypeApiEnum.COVERAGE_COMPARISON],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON, ReportBlockTypeApiEnum.SENTIMENT_BREAKDOWN_COMPARISON],
    [ReportBlockTypeEnum.SENTIMENT_TREND, ReportBlockTypeApiEnum.SENTIMENT_TREND],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON, ReportBlockTypeApiEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_COMPARISON, ReportBlockTypeApiEnum.GEOGRAPHY_BREAKDOWN_COMPARISON],
    [ReportBlockTypeEnum.COVERAGE_SUMMARY, ReportBlockTypeApiEnum.COVERAGE_SUMMARY],
    [ReportBlockTypeEnum.COVERAGE_METRIC, ReportBlockTypeApiEnum.COVERAGE_METRIC],
    [ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, ReportBlockTypeApiEnum.COVERAGE_IMPACT_TREND],
    [ReportBlockTypeEnum.REFERRAL_TREND, ReportBlockTypeApiEnum.REFERRAL_TREND],
    [ReportBlockTypeEnum.PROMINENCE_OVER_TIME, ReportBlockTypeApiEnum.PROMINENCE_OVER_TIME],
    [ReportBlockTypeEnum.PROMINENCE_BY_REACH, ReportBlockTypeApiEnum.PROMINENCE_BY_REACH],
    [ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS, ReportBlockTypeApiEnum.TOP_SOCIAL_REFERRERS],
    [ReportBlockTypeEnum.TOP_REFERRAL_SOURCES, ReportBlockTypeApiEnum.TOP_REFERRAL_SOURCES],
    [ReportBlockTypeEnum.RECENT_TOPICS, ReportBlockTypeApiEnum.RECENT_TOPICS],
    [ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY, ReportBlockTypeApiEnum.RECENT_TARGETING_ACTIVITY],
    [ReportBlockTypeEnum.RECENT_DISTRIBUTION_ACTIVITY, ReportBlockTypeApiEnum.RECENT_DISTRIBUTION_ACTIVITY],
    [ReportBlockTypeEnum.RECENT_REPORTS_DISTRIBUTIONS, ReportBlockTypeApiEnum.RECENT_REPORTS_DISTRIBUTIONS],
    [ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK, ReportBlockTypeApiEnum.SOCIAL_COVERAGE_BY_NETWORK],
    [ReportBlockTypeEnum.TOP_TERMS, ReportBlockTypeApiEnum.TOP_TERMS],
    [ReportBlockTypeEnum.RECENT_SURGE_ALERTS, ReportBlockTypeApiEnum.RECENT_SURGE_ALERTS],
    [ReportBlockTypeEnum.TOP_MENTIONS, ReportBlockTypeApiEnum.TOP_MENTIONS],
    [ReportBlockTypeEnum.TOP_POSTS, ReportBlockTypeApiEnum.TOP_POSTS],
]);

export const reportBlockTypeEnumFromApi = new Map<ReportBlockTypeApiEnum, ReportBlockTypeEnum>([
    [ReportBlockTypeApiEnum.SENTIMENT_BREAKDOWN, ReportBlockTypeEnum.SENTIMENT_BREAKDOWN],
    [ReportBlockTypeApiEnum.MEDIA_TYPE_BREAKDOWN, ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN],
    [ReportBlockTypeApiEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME],
    [ReportBlockTypeApiEnum.TOP_10_OUTLETS, ReportBlockTypeEnum.TOP_10_OUTLETS],
    [ReportBlockTypeApiEnum.TOP_SOCIAL_INFLUENCERS, ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME],
    [ReportBlockTypeApiEnum.TOP_HASHTAGS, ReportBlockTypeEnum.TOP_HASHTAGS],
    [ReportBlockTypeApiEnum.WORD_CLOUD, ReportBlockTypeEnum.WORD_CLOUD],
    [ReportBlockTypeApiEnum.AUDIENCE_REACH_BY_MEDIA_TYPE, ReportBlockTypeEnum.AUDIENCE_REACH_BY_MEDIA_TYPE],
    [ReportBlockTypeApiEnum.POSITION_BREAKDOWN, ReportBlockTypeEnum.POSITION_BREAKDOWN],
    [ReportBlockTypeApiEnum.SHARE_OF_VOICE, ReportBlockTypeEnum.SHARE_OF_VOICE],
    [ReportBlockTypeApiEnum.COVERAGE_OVER_TIME, ReportBlockTypeEnum.COVERAGE_OVER_TIME],
    [ReportBlockTypeApiEnum.COVERAGE_OVER_TIME_COMPARISON, ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON],
    [ReportBlockTypeApiEnum.AD_VALUE_EQUIVILANCY, ReportBlockTypeEnum.COVERAGE_OVER_TIME],
    [ReportBlockTypeApiEnum.AD_VALUE_EQUIVILANCY_COMPARISON, ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON],
    [ReportBlockTypeApiEnum.AUDIENCE_REACH_OVER_TIME, ReportBlockTypeEnum.COVERAGE_OVER_TIME],
    [ReportBlockTypeApiEnum.AUDIENCE_REACH_OVER_TIME_COMPARISON, ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON],
    [ReportBlockTypeApiEnum.COVERAGE_COMPARISON, ReportBlockTypeEnum.COVERAGE_COMPARISON],
    [ReportBlockTypeApiEnum.SENTIMENT_BREAKDOWN_COMPARISON, ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON],
    [ReportBlockTypeApiEnum.SENTIMENT_TREND, ReportBlockTypeEnum.SENTIMENT_TREND],
    [ReportBlockTypeApiEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON, ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON],
    [ReportBlockTypeApiEnum.GEOGRAPHY_BREAKDOWN_COMPARISON, ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_COMPARISON],
    [ReportBlockTypeApiEnum.COVERAGE_SUMMARY, ReportBlockTypeEnum.COVERAGE_SUMMARY],
    [ReportBlockTypeApiEnum.COVERAGE_METRIC, ReportBlockTypeEnum.COVERAGE_METRIC],
    [ReportBlockTypeApiEnum.COVERAGE_IMPACT_TREND, ReportBlockTypeEnum.COVERAGE_IMPACT_TREND],
    [ReportBlockTypeApiEnum.REFERRAL_TREND, ReportBlockTypeEnum.REFERRAL_TREND],
    [ReportBlockTypeApiEnum.PROMINENCE_OVER_TIME, ReportBlockTypeEnum.PROMINENCE_OVER_TIME],
    [ReportBlockTypeApiEnum.PROMINENCE_BY_REACH, ReportBlockTypeEnum.PROMINENCE_BY_REACH],
    [ReportBlockTypeApiEnum.TOP_SOCIAL_REFERRERS, ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS],
    [ReportBlockTypeApiEnum.TOP_REFERRAL_SOURCES, ReportBlockTypeEnum.TOP_REFERRAL_SOURCES],
    [ReportBlockTypeApiEnum.RECENT_TOPICS, ReportBlockTypeEnum.RECENT_TOPICS],
    [ReportBlockTypeApiEnum.RECENT_TARGETING_ACTIVITY, ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY],
    [ReportBlockTypeApiEnum.RECENT_DISTRIBUTION_ACTIVITY, ReportBlockTypeEnum.RECENT_DISTRIBUTION_ACTIVITY],
    [ReportBlockTypeApiEnum.RECENT_REPORTS_DISTRIBUTIONS, ReportBlockTypeEnum.RECENT_REPORTS_DISTRIBUTIONS],
    [ReportBlockTypeApiEnum.SOCIAL_COVERAGE_BY_NETWORK, ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK],
    [ReportBlockTypeApiEnum.TOP_TERMS, ReportBlockTypeEnum.TOP_TERMS],
    [ReportBlockTypeApiEnum.RECENT_SURGE_ALERTS, ReportBlockTypeEnum.RECENT_SURGE_ALERTS],
    [ReportBlockTypeApiEnum.TOP_MENTIONS, ReportBlockTypeEnum.TOP_MENTIONS],
    [ReportBlockTypeApiEnum.TOP_POSTS, ReportBlockTypeEnum.TOP_POSTS]
]);


export const reportBlockTypeEnumToDefaultChartSpecificType = new Map<ReportBlockTypeEnum, ChartSpecificTypesEnum>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, ChartSpecificTypesEnum.LINE],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN, ChartSpecificTypesEnum.PIE],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN, ChartSpecificTypesEnum.PIE],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, ChartSpecificTypesEnum.MAP],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.TOP_HASHTAGS, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.WORD_CLOUD, ChartSpecificTypesEnum.WORD_CLOUD],
    [ReportBlockTypeEnum.AUDIENCE_REACH_BY_MEDIA_TYPE, ChartSpecificTypesEnum.PIE],
    [ReportBlockTypeEnum.POSITION_BREAKDOWN, ChartSpecificTypesEnum.PIE],
    [ReportBlockTypeEnum.SHARE_OF_VOICE, ChartSpecificTypesEnum.PIE],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, ChartSpecificTypesEnum.LINE],
    [ReportBlockTypeEnum.COVERAGE_COMPARISON, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN],
    [ReportBlockTypeEnum.SENTIMENT_TREND, ChartSpecificTypesEnum.LINE],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN],
    [ReportBlockTypeEnum.COVERAGE_SUMMARY, ChartSpecificTypesEnum.VALUES_LIST],
    [ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, ChartSpecificTypesEnum.LINE],
    [ReportBlockTypeEnum.REFERRAL_TREND, ChartSpecificTypesEnum.MULTI_LINE],
    [ReportBlockTypeEnum.PROMINENCE_OVER_TIME, ChartSpecificTypesEnum.FILLED_LINE],
    [ReportBlockTypeEnum.PROMINENCE_BY_REACH, ChartSpecificTypesEnum.HEAT],
    [ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.TOP_REFERRAL_SOURCES, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK, ChartSpecificTypesEnum.BAR],
    [ReportBlockTypeEnum.TOP_TERMS, ChartSpecificTypesEnum.LIST],
    [ReportBlockTypeEnum.TOP_MENTIONS, ChartSpecificTypesEnum.LIST],
    [ReportBlockTypeEnum.COVERAGE_METRIC, ChartSpecificTypesEnum.LINE]
]);

export const reportBlockTypesToSetupDialogAccentColorMapKeysMap = new Map<ReportBlockTypeEnum, string[]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, ['metric0']],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_HASHTAGS, ['seriesColor0']],
    [ReportBlockTypeEnum.SHARE_OF_VOICE, ['seriesColor0', 'subSource1']],
    [ReportBlockTypeEnum.COVERAGE_COMPARISON, ['seriesColor0', 'subSource1']],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, ['highValue', 'region1']],
    [ReportBlockTypeEnum.PROMINENCE_OVER_TIME, ['seriesColor0']],
    [ReportBlockTypeEnum.PROMINENCE_BY_REACH, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_TERMS, ['barColor']],
    [ReportBlockTypeEnum.COVERAGE_SUMMARY, ['metric0']],
    [ReportBlockTypeEnum.COVERAGE_METRIC, ['accentColor']]
]);

// see D19564, top 10 charts work with barColor in the setup dialog, but changes it to seriesColor0 when exiting the dialog, so a different map is
export const reportBlockTypesToNewAccentColorMapKeysMap = new Map<ReportBlockTypeEnum, string[]>([
    [ReportBlockTypeEnum.TOP_10_OUTLETS, ['barColor']],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, ['barColor']]
]);

export const reportBlockTypesToChartAccentColorMapkeysMap = new Map<ReportBlockTypeEnum, string[]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, ['analysisColor1']],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, ['barColor']],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_HASHTAGS, ['barColor']],
    [ReportBlockTypeEnum.SHARE_OF_VOICE, ['seriesColor0', 'subSource1']],
    [ReportBlockTypeEnum.COVERAGE_COMPARISON, ['seriesColor0', 'subSource1']],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, ['choroplethHighValue', 'region1']],
    [ReportBlockTypeEnum.PROMINENCE_OVER_TIME, ['seriesColor0']],
    [ReportBlockTypeEnum.PROMINENCE_BY_REACH, ['seriesColor0']],
    [ReportBlockTypeEnum.TOP_TERMS, ['barColor']],
    [ReportBlockTypeEnum.COVERAGE_SUMMARY, ['analysisColor1']],
    [ReportBlockTypeEnum.COVERAGE_METRIC, ['accentColor']]
]);

export const chartSpecificTypesToBaseAxisDirectionsMap = new Map<ChartSpecificTypesEnum, string>([
    [ ChartSpecificTypesEnum.BAR, 'yAxes' ],
    [ ChartSpecificTypesEnum.COLUMN, 'xAxes' ],
    [ ChartSpecificTypesEnum.LINE, 'xAxes' ],
    [ ChartSpecificTypesEnum.FILLED_LINE, 'xAxes' ],
    [ ChartSpecificTypesEnum.MULTI_LINE, 'xAxes' ],
    [ ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, 'xAxes' ],
    [ ChartSpecificTypesEnum.MULTI_STACKED_BAR, 'yAxes' ]
]);

export const chartSpecificTypesToValueAxisDirectionsMap = new Map<ChartSpecificTypesEnum, string>([
    [ ChartSpecificTypesEnum.BAR, 'xAxes' ],
    [ ChartSpecificTypesEnum.COLUMN, 'yAxes' ],
    [ ChartSpecificTypesEnum.LINE, 'yAxes' ],
    [ ChartSpecificTypesEnum.FILLED_LINE, 'yAxes' ],
    [ ChartSpecificTypesEnum.MULTI_LINE, 'yAxes' ],
    [ ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, 'yAxes' ],
    [ ChartSpecificTypesEnum.MULTI_STACKED_BAR, 'xAxes' ]
]);

export enum ReportChartSourcesTypeEnum {
    none,
    single,
    multi,
}

export interface ReportChartInfo {
    mentions?: ReportChartSourcesTypeEnum;
    mentionFacets?: MentionSearchFacetTypesEnum[];
    aggregateDateFacets?: AggregateDateFacetTypesEnum[];
    externalData?: ReportChartSourcesTypeEnum;
    neoFacetRequestApiModel?: NeoFacetRequestApiModel[];
    googleAnalyticsReportType?: GoogleAnalyticsReportRequestTypeEnum;
    dynamicTitle?: boolean;
    dimensions: DimensionsModel;
}

export const reportChartInfoMap = new Map<ReportBlockTypeEnum, ReportChartInfo>([
    [
        ReportBlockTypeEnum.COVERAGE_OVER_TIME,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            // @TODO: empty this when saved mentions search support neofacets
            aggregateDateFacets: [ AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH ],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                coverageOverTimeNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(2, 4)
        }
    ],
    [
        ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets: [
                MentionSearchFacetTypesEnum.mediaType
            ],
            dimensions: new DimensionsModel(2, 3)
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_BREAKDOWN,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
            ],
            dimensions: new DimensionsModel(2, 3)
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_TREND,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                sentimentTrendNeoFacet
            ],
            dimensions: new DimensionsModel(3, 4)
        }
    ],
    [
        ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            mentionFacets:  [],
            neoFacetRequestApiModel: [
                mapChartNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 4)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_10_OUTLETS,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets:  [
                MentionSearchFacetTypesEnum.outlet,
                MentionSearchFacetTypesEnum.outletByAudienceReach,
                MentionSearchFacetTypesEnum.outletByAVE,
                MentionSearchFacetTypesEnum.outletByDomainAuthority
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets:  [
                MentionSearchFacetTypesEnum.contact,
                MentionSearchFacetTypesEnum.authorByAudienceReach,
                MentionSearchFacetTypesEnum.authorByAVE,
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_HASHTAGS,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets:  [
                MentionSearchFacetTypesEnum.hashtags,
            ],
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_SUMMARY,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [ AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH ],
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
            ],
            neoFacetRequestApiModel: [
                engagementsNeoFacet,
                audienceReachNeoFacet
            ],
            dimensions: new DimensionsModel(3, 3)
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            // @TODO: empty this when saved mentions search support neofacets
            aggregateDateFacets: [ AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH ],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                coverageOverTimeNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(3, 4)
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            aggregateDateFacets: [],
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
            ],
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            aggregateDateFacets: [],
            mentionFacets: [
                MentionSearchFacetTypesEnum.mediaType
            ],
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.SHARE_OF_VOICE,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            aggregateDateFacets: [
                AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH,
                AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD
            ],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                totalEngagementFacet,
                coverageOverTimeNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(2, 3)
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_COMPARISON,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            // @TODO: empty this when saved mentions search support neofacets
            aggregateDateFacets: [ AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH ],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                totalEngagementFacet,
                coverageOverTimeNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.REFERRAL_TREND,
        {
            externalData: ReportChartSourcesTypeEnum.single,
            googleAnalyticsReportType: GoogleAnalyticsReportRequestTypeEnum.REFERRAL_TREND,
            mentions: ReportChartSourcesTypeEnum.none,
            dimensions: new DimensionsModel(3, 4)
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
        {
            externalData: ReportChartSourcesTypeEnum.single,
            googleAnalyticsReportType: GoogleAnalyticsReportRequestTypeEnum.COVERAGE_IMPACT_TREND,
            mentions: ReportChartSourcesTypeEnum.single,
            mentionFacets: [],
            neoFacetRequestApiModel: [
                coverageOverTimeNeoFacet
            ],
            aggregateDateFacets: [
                AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH
            ],
            dimensions: new DimensionsModel(3, 4)
        }
    ],
    [
        ReportBlockTypeEnum.PROMINENCE_OVER_TIME,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
                MentionSearchFacetTypesEnum.mediaType
            ],
            dimensions: new DimensionsModel(3, 4)
        }
    ],
    [
        ReportBlockTypeEnum.PROMINENCE_BY_REACH,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
                MentionSearchFacetTypesEnum.mediaType
            ],
            dimensions: new DimensionsModel(4, 4)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS,
        {
            externalData: ReportChartSourcesTypeEnum.single,
            googleAnalyticsReportType: GoogleAnalyticsReportRequestTypeEnum.TOP_SOCIAL_REFERRERS_SESSIONS,
            mentions: ReportChartSourcesTypeEnum.none,
            mentionFacets: [],
            dimensions: new DimensionsModel(4, 3)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_REFERRAL_SOURCES,
        {
            externalData: ReportChartSourcesTypeEnum.single,
            mentions: ReportChartSourcesTypeEnum.none,
            mentionFacets: [],
            dimensions: new DimensionsModel(4, 3)
        }
    ],

    // Not in use yet
    [
        ReportBlockTypeEnum.AUDIENCE_REACH_BY_MEDIA_TYPE,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            mentionFacets: [],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.WORD_CLOUD,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            mentionFacets:  [
                // word cloud needs a new special facet type @TODO
                MentionSearchFacetTypesEnum.outlet,
                MentionSearchFacetTypesEnum.outletByAudienceReach,
                MentionSearchFacetTypesEnum.outletByAVE,
                MentionSearchFacetTypesEnum.contact,
                MentionSearchFacetTypesEnum.authorByAudienceReach,
                MentionSearchFacetTypesEnum.authorByAVE,
                MentionSearchFacetTypesEnum.country,
                MentionSearchFacetTypesEnum.province,
                MentionSearchFacetTypesEnum.language,
                MentionSearchFacetTypesEnum.hashtags,
            ],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.POSITION_BREAKDOWN,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            mentionFacets:  [
                MentionSearchFacetTypesEnum.outlet,
                MentionSearchFacetTypesEnum.outletByAudienceReach,
                MentionSearchFacetTypesEnum.outletByAVE,
                MentionSearchFacetTypesEnum.contact,
                MentionSearchFacetTypesEnum.authorByAudienceReach,
                MentionSearchFacetTypesEnum.authorByAVE,
                MentionSearchFacetTypesEnum.country,
                MentionSearchFacetTypesEnum.province,
                MentionSearchFacetTypesEnum.language,
                MentionSearchFacetTypesEnum.hashtags,
            ],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_COMPARISON,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            mentionFacets:  [
                MentionSearchFacetTypesEnum.outlet,
                MentionSearchFacetTypesEnum.outletByAudienceReach,
                MentionSearchFacetTypesEnum.outletByAVE,
                MentionSearchFacetTypesEnum.contact,
                MentionSearchFacetTypesEnum.authorByAudienceReach,
                MentionSearchFacetTypesEnum.authorByAVE,
                MentionSearchFacetTypesEnum.country,
                MentionSearchFacetTypesEnum.province,
                MentionSearchFacetTypesEnum.language,
                MentionSearchFacetTypesEnum.hashtags,
            ],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.RECENT_TOPICS,
        {
            mentions: ReportChartSourcesTypeEnum.multi,
            aggregateDateFacets: [ AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH ],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY,
        {
            mentions: ReportChartSourcesTypeEnum.none,
            aggregateDateFacets: [],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.RECENT_DISTRIBUTION_ACTIVITY,
        {
            mentions: ReportChartSourcesTypeEnum.none,
            aggregateDateFacets: [],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.RECENT_REPORTS_DISTRIBUTIONS,
        {
            mentions: ReportChartSourcesTypeEnum.none,
            aggregateDateFacets: [],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            neoFacetRequestApiModel: [
                socialCoverageByNetworkNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(3, 3)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_TERMS,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets: [],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 4)
        }
    ],
    [
        ReportBlockTypeEnum.RECENT_SURGE_ALERTS,
        {
            mentions: ReportChartSourcesTypeEnum.none,
            aggregateDateFacets: [],
            dimensions: new DimensionsModel(2, 2)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_MENTIONS,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [
                AggregateDateFacetTypesEnum.SUM_AD_VALUE_USD, AggregateDateFacetTypesEnum.SUM_AUDIENCE_REACH
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(5, 4)
        }
    ],
    [
        ReportBlockTypeEnum.TOP_POSTS,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [],
            mentionFacets: [],
            neoFacetRequestApiModel: [
                coverageOverTimeNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(4, 4)
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_METRIC,
        {
            mentions: ReportChartSourcesTypeEnum.single,
            aggregateDateFacets: [AggregateDateFacetTypesEnum.SUM_DOMAIN_AUTHORITY],
            mentionFacets: [
                MentionSearchFacetTypesEnum.sentiment,
            ],
            neoFacetRequestApiModel: [
                coverageOverTimeNeoFacet,
                engagementsNeoFacet,
                audienceReachNeoFacet,
                sentimentTrendNeoFacet
            ],
            dynamicTitle: true,
            dimensions: new DimensionsModel(2, 2)
        }
    ]
]);
